import React from 'react';

import styles from './SkeletonLoader.module.scss';

const SkeletonLoader = () => (
  <div className={styles.container}>
    {/* Title skeleton */}
    <div className={styles.skeletonLine} style={{ width: '55%', height: 22, marginBottom: 20 }} />

    {/* Job info card skeleton */}
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonCardHeader}>
        <div className={styles.skeletonAvatar} />
        <div className={styles.skeletonCardHeaderText}>
          <div className={styles.skeletonLine} style={{ width: '60%', height: 14 }} />
          <div className={styles.skeletonLine} style={{ width: '40%', height: 12 }} />
          <div className={styles.skeletonLine} style={{ width: '30%', height: 11 }} />
        </div>
      </div>
      <div className={styles.skeletonLine} style={{ width: '18%', height: 26, borderRadius: 20 }} />
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <div className={styles.skeletonLine} style={{ width: '22%', height: 14 }} />
        <div className={styles.skeletonLine} style={{ width: '15%', height: 14 }} />
      </div>
      <div className={styles.skeletonLine} style={{ width: '28%', height: 36, borderRadius: 8, marginTop: 16 }} />
    </div>

    {/* Providers card skeleton */}
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonLine} style={{ width: '35%', height: 14, marginBottom: 14 }} />
      {[1, 2].map((i) => (
        <div key={i} className={styles.skeletonProviderRow}>
          <div className={styles.skeletonAvatarSmall} />
          <div style={{ flex: 1 }}>
            <div className={styles.skeletonLine} style={{ width: '45%', height: 12 }} />
            <div className={styles.skeletonLine} style={{ width: '30%', height: 10, marginTop: 4 }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default SkeletonLoader;
